import React, { useState, useEffect, useRef } from 'react';
import './ForgotPasswordModal.css';
import { API_BASE_URL } from '../config/apiConfig';

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  const handleReset = async () => {
    if (!email) {
      setError('Please enter your email.');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      const res = await fetch(`${API_BASE_URL}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('✅ If the email is registered, a reset link has been sent.');
      } else {
        setMessage(data.message || '❌ Unable to send reset link.');
      }
    } catch (err) {
      setMessage('❌ Could not connect to the server. Please make sure it’s running.');
      console.error('Network error:', err);
    } finally {
      setLoading(false);
      setEmail('');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-content">
        <h2>🧵 Forgot Password</h2>
        <input
          type="email"
          placeholder="Enter your registered email"
          value={email}
          ref={inputRef}
          onChange={(e) => {
            setEmail(e.target.value);
            setError('');
            setMessage('');
          }}
          required
        />
        {error && <p className="error-msg">{error}</p>}
        <button onClick={handleReset} disabled={loading}>
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
        <button onClick={onClose} className="close-btn">Close</button>
        {message && <p className="forgot-password-message">{message}</p>}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
